import { useEffect } from "react";
import { Hero } from "./Hero";
import { Categories } from "./Categories";
import { PlatformFeatures } from "./PlatformFeatures";
import { PracticePreview } from "./PracticePreview";
import { HowItWorks } from "./HowItWorks";
import { Benefits } from "./Benefits";
import { Testimonials } from "./Testimonials";
import { Pricing } from "./Pricing";
import { Faqs } from "./Faqs";
import { FinalCta } from "./FinalCta";
import { Reveal } from "../../components/public/ui";
import {
  handleAnchorClick,
  smoothScrollToElement,
} from "../../components/public/smoothScroll";

export const Home = () => {
  // Smooth scrolling for in-page links (#pricing, #faqs, ...) while the home page is mounted
  useEffect(() => {
    // Arriving with a hash (e.g. /#faqs), or the hash being edited in the address bar
    const scrollToHash = () => {
      const target = window.location.hash
        ? document.getElementById(window.location.hash.slice(1))
        : null;
      if (target) smoothScrollToElement(target);
    };

    document.addEventListener("click", handleAnchorClick);
    window.addEventListener("hashchange", scrollToHash);
    const frame = requestAnimationFrame(scrollToHash);

    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener("click", handleAnchorClick);
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, []);

  return (
    <main className="w-full pt-20 bg-surface">
      <div className="flex flex-col w-full">
        <Hero />
        <Reveal>
          <Categories />
        </Reveal>
        <Reveal>
          <PlatformFeatures />
        </Reveal>
        <Reveal>
          <PracticePreview />
        </Reveal>
        <Reveal>
          <HowItWorks />
        </Reveal>
        <Reveal>
          <Benefits />
        </Reveal>
        <Reveal>
          <Testimonials />
        </Reveal>
        <Reveal>
          <Pricing />
        </Reveal>
        <Reveal>
          <Faqs />
        </Reveal>
        <Reveal>
          <FinalCta />
        </Reveal>
      </div>
    </main>
  );
};
